import cs from "classnames";
import { ReactNode } from "react";
import { Text } from "../../Type";
import styles from "./index.module.scss";

const EmptyView = ({
  message,
  className,
  children,
}: {
  message: string;
  className?: string;
  children?: ReactNode | ReactNode[];
}) => {
  return (
    <div className={cs(styles.emptyContainer, className)}>
      <Text className={styles.emptyText}>{message}</Text>
      {children}
    </div>
  );
};

export default EmptyView;
